import { apiFetch, apiFetchBlob } from './client.js';
import type { ReportCurrency, ReportExportFormat } from './report-transactions.api.js';

/** Reports → Commissions (DEV-128, stage 1). Amounts are integer minor-unit strings in the reporting currency; null = a rate is missing. */

export interface CommissionReportTotals {
  operations: number;
  turnoverMinor: string | null;
  feeMinor: string | null;
  /** Commissions on completed payments: the effective rate's numerator. */
  paymentFeeMinor: string | null;
  /** Onboarding, monthly and other commissions not tied to a payment. */
  standaloneFeeMinor: string | null;
  missingRates: number;
}

/** One calendar month of the period; `partial` when the period covers only `from`–`to` of it (YYYY-MM-DD, UTC). */
export interface CommissionMonth {
  month: string;
  from: string;
  to: string;
  partial: boolean;
  operations: number;
  turnoverMinor: string | null;
  feeMinor: string | null;
}
export interface CommissionByFee { feeName: string; operations: number; turnoverMinor: string | null; feeMinor: string | null }
export interface CommissionByCustomer {
  key: string;
  label: string;
  customerType: 'B' | 'C' | 'UNKNOWN';
  operations: number;
  turnoverMinor: string | null;
  feeMinor: string | null;
}

export interface CommissionReport {
  /** YYYY-MM-DD, inclusive, UTC. */
  from: string;
  through: string;
  reportingCurrency: ReportCurrency;
  /** When the reporting table was last refreshed; null while it is built for the first time. */
  refreshedAt: string | null;
  loadedAt: string;
  totals: CommissionReportTotals;
  monthly: CommissionMonth[];
  byFee: CommissionByFee[];
  byCustomer: CommissionByCustomer[];
}

export const reportCommissionsApi = {
  read: (query: string): Promise<CommissionReport> => apiFetch(`/admin/reports/commissions?${query}`),
  export: (query: string, format: ReportExportFormat): Promise<Blob> =>
    apiFetchBlob(`/admin/reports/commissions/export?${query}&format=${format}`),
};
